/** Keep in sync with endchess-backend entitlementsConstants free-tier values. */
export const GUEST_FREE_REPLAY_NEW_GAME_COOLDOWN_DAYS = 1;
export const GUEST_FREE_REPLAY_HISTORY_LIMIT = 10;

export const guestAccessSummary =
  'You can use Endchess as a guest with a 90-day free trial — full access to puzzles, review, explorer, and unlimited replay.';

export const guestMergeOnSignInNote =
  'When you sign in or create an account, any guest progress from this browser is merged into your account automatically.';

export const guestReplayLimitReachedToast =
  'Your guest trial has ended. Create an account to start a new 90-day free trial, or upgrade to Pro for unlimited access.';
